<template>
  <origin-groups-form
    :distribution-id="distributionId"
    @submit="addOrigin"
    @close="onClose"
  />
</template>
<script>
import OriginGroupsForm from './OriginGroupsForm.vue'

export default {
  name: 'CreateOriginGroup',
  components: {
    OriginGroupsForm,
  },
  data() {
    return {
      distributionId: null,
    }
  },
  created() {
    this.distributionId = this.$route.params.id
  },
  methods: {
    addOrigin(query) {
      this.$store.dispatch('cdn/addOriginGroup', query.originGroup).then(() => {
        this.successToast('Origin group was added')
        this.onClose()
      }).catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while creating origin group.') })
    },

    onClose() {
      this.$router.push({ name: 'distribution-origins', params: { id: this.distributionId, activeTab: 1 } })
    },
  },
}
</script>
